import http from './utils';
import { prefix, mockPrefix } from './constants';

export const getGlobalResourceConfig: (
  payload: any,
) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/last_available_time`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
};
